
import { defineComponent, ref, onBeforeMount, computed, reactive } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { TCheckbox, TButton } from '@tencent/web-vbui';
import { RightSelect } from './components';
import { spin } from '@tencent/web-vbui/src/components/t-spin/spin';
import { useGlobalState } from '../../store/carOwnerRight';
import { GetActivityList, GetActivityRecord, CheckAwardStock, JoinActivity } from '../../core/network/NodeAPI';
import { i18n, reportStatistics } from '@tencent/vb-web-base';
import { to } from '@tencent/vb-web-base-core';
import { baseMixins } from '@common/mixins/baseMixins';
import dayjs from 'dayjs';
import Contract from '@tencent/vb-web-contract';
import { ProductInfoMap, BaseProductNoMap } from '@common/core/help/constant';
import { NetworkError } from '@common/lib/error';
enum ActState {
  ACTIVITY_INIT = 1,
  ACTIVITY_APPROVING = 2,
  ACTIVITY_UN_APPROVED = 3,
  ACTIVITY_APPROVED = 4,
  ACTIVITY_ONLINE = 5,
  ACTIVITY_OFFLINE = 6,
  ACTIVITY_DISABLE = 7,
  ACTIVITY_ONLINE_APPROVING = 8,
  ACTIVITY_OFFLINE_APPROVING = 9,
}

export default defineComponent({
  name: 'RightDetail',
  components: {
    TCheckbox,
    TButton,
    RightSelect,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const { brand } = route.query;
    const state = useGlobalState();
    const detail = computed(() => state.value.detail);
    const date = computed(() => state.value.date);
    const { userStatus } = state.value;
    const { getT } = i18n;
    // i18n.setLang('en-GB');
    const $t = getT();
    const { setTitle, showModalError } = baseMixins();
    setTitle($t('我的专属礼遇'));
    const isAgree = ref(false);
    const isSign = ref(true);
    const contractInstance = new Contract({
      key: brand === 'tesla' ? 'TeslaOwnerRight' : 'CarOwnerRight',
      autoSign: false,
      containerType: 'dialog',
      needAgree: false,
      needCheckBox: false,
      hideBtn: true,
      needTitle: false,
    });
    // 奖品规格选择
    const selectValue = ref('');
    const selectOptions = computed(
      () =>
        detail.value.rightSize?.length &&
        detail.value.rightSize.map((item, index) => {
          const obj: { label: string; value: string } = { label: '', value: '' };
          obj.label = item;
          obj.value = detail.value.activity?.[index];
          return obj;
        }),
    );
    // 检查协议是否已经签约
    const checkIsSign = async () => {
      const returnObj = await contractInstance.checkSign();
      if (returnObj.msg === 'hasContract') {
        isSign.value = true;
      } else {
        isSign.value = false;
      }
    };
    // 立即领取
    const handleClick = async () => {
      try {
        spin.show();
        reportStatistics({
          evtName: `${brand}drawBtnClick`,
          desc: `奖品详情页面${detail.value.detailName}立即领取按钮点击`,
        });
        await contractInstance.sign();
        await JoinActivity({
          activityNo: selectValue.value || detail.value.activity?.[0],
          proNo: userStatus.proNo || (brand === 'tesla' ? ProductInfoMap.TESLA : ProductInfoMap.DEFAULT),
          baseProNo: userStatus.baseProNo || (brand === 'tesla' ? BaseProductNoMap.TESLA : BaseProductNoMap.DEFAULT),
          startTime: date.value[0],
          endTime: date.value[1],
        });
        spin.hide();
        router.replace({
          path: '/rightState',
          query: {
            ...route.query,
          },
        });
      } catch (error) {
        const err = error as NetworkError;
        spin.hide();
        showModalError(err.message, err.code);
      }
    };

    // 获取权益活动配置
    const activityInfo = reactive<{
      activityDate: string[];
      activityState: string;
      activityStartTime: number;
      activityStartEndTime: number;
      award_conf_ids: string;
    }>({
      activityDate: [],
      activityState: '',
      award_conf_ids: '',
      activityStartTime: -1,
      activityStartEndTime: -1
    });
    const getActivityInfo = async () => {
      const activityNo = detail.value.activity?.[0];
      const [data, err] = await to(GetActivityList(activityNo));
      if (err) {
        showModalError(err.message, err.code);
        return;
      }
      const activityConfInfo = data.list[0];
      activityInfo.activityStartTime = Number(activityConfInfo.start_time);
      activityInfo.activityStartEndTime = Number(activityConfInfo.end_time);
      activityInfo.activityDate[0] = dayjs(Number(activityConfInfo.start_time)).format('YYYY-MM-DD');
      activityInfo.activityDate[1] = dayjs(Number(activityConfInfo.end_time)).format('YYYY-MM-DD');
      activityInfo.activityState = activityConfInfo.state;
      activityInfo.award_conf_ids = activityConfInfo.award_conf_ids;
    };
    // 获取权益累计已领取数量
    const curReceiveCount = ref(0);
    const getCurReceiveCount = async () => {
      const [data, err] = await to(
        GetActivityRecord({
          activityNoList: detail.value.activity,
        }),
      );
      if (err) {
        showModalError(err.message, err.code);
        return;
      }
      curReceiveCount.value = data.total;
    };

    // 获取当月权益累计已领取数量
    const curMonthReceiveCount = ref(0);
    const getCurMonthReceiveCount = async () => {
      const [data, err] = await to(
        GetActivityRecord({
          activityNoList: detail.value.activity,
          startTime: dayjs().startOf('month').valueOf(),
          endTime: dayjs().endOf('month').valueOf(),
        }),
      );
      if (err) {
        showModalError(err.message, err.code);
        return;
      }
      curMonthReceiveCount.value = data.total;
    };

    // 查询奖品库存
    const isStock = ref(true);
    const getAwardStock = async () => {
      const res = await CheckAwardStock(activityInfo.award_conf_ids);
      if (res.stock === 0) {
        isStock.value = false;
      }
    };

    // 查看协议
    const checkProto = () => {
      contractInstance.preview();
    };

    onBeforeMount(async () => {
      await getActivityInfo();
      checkIsSign();
      getCurReceiveCount();
      getCurMonthReceiveCount();
      getAwardStock();
    });

    const btnState = computed(() => {
      const a = ActState[1];
      console.log(a);
      if (
        activityInfo.activityState === ActState[1] ||
        activityInfo.activityState === ActState[8] ||
        dayjs().isBefore(dayjs(activityInfo.activityStartTime))
      ) {
        return {
          text: $t('即将开始'),
          state: 'disabled',
        };
      }
      if (
        activityInfo.activityState === ActState[6] ||
        activityInfo.activityState === ActState[7] ||
        activityInfo.activityState === ActState[9] ||
        dayjs().isAfter(dayjs(activityInfo.activityStartEndTime))
      ) {
        return {
          text: $t('活动已结束'),
          state: 'disabled',
        };
      }
      if (!isStock.value) {
        return {
          text: $t('暂无库存'),
          state: 'disabled',
        };
      }
      if (curReceiveCount.value >= Number(detail.value.detailInfoReceiveCount)) {
        return {
          text: $t('已领取'),
          state: 'disabled',
        };
      }
      if (curMonthReceiveCount.value >= Number(detail.value.detailInfoReceiveMonthCount)) {
        return {
          text: $t('本月已领取'),
          state: 'disabled',
        };
      }
      return {
        text: $t('立即领取'),
        state: 'normal',
      };
    });
    return {
      brand,
      detail,
      activityInfo,
      curReceiveCount,
      isAgree,
      isSign,
      selectValue,
      selectOptions,
      checkProto,
      btnState,
      handleClick,
    };
  },
});
